import React from 'react'

import {
  AccommodationForChannelMapping,
  ChannelMappingWithRatePlanInput,
  ChannelMappingWithoutRatePlanInput,
  RatePlanForChannelMappingWithRatePlanInput,
  RatePlanForChannelapping
} from '../../types/channelMapping'
import RoomTypeItemBox from './RoomTypeItemBox'
import RoomTypeItemBoxSkeleton from './RoomTypeItemBox.skeleton'
import useStyles from './styles/RoomTypesList.styles'

interface RoomTypesListProps {
  EditModal: any
  selectedAccommodation: AccommodationForChannelMapping | undefined
  loading: boolean
  parametersForWithoutRateplan: ChannelMappingWithoutRatePlanInput
  updatedParametersForWithoutRateplan: ChannelMappingWithoutRatePlanInput
  setUpdatedParametersForWithoutRateplan: React.Dispatch<
    React.SetStateAction<ChannelMappingWithoutRatePlanInput>
  >
  parametersForMultiRateplan: ChannelMappingWithRatePlanInput
  setParametersForMultiRateplan: React.Dispatch<
    React.SetStateAction<ChannelMappingWithRatePlanInput>
  >
  updatedParametersForMultiRateplan: ChannelMappingWithRatePlanInput
  setUpdatedParametersForMultiRateplan: React.Dispatch<
    React.SetStateAction<ChannelMappingWithRatePlanInput>
  >

  haveSuppurtRatePlans: boolean
  searchInput: string
}
const RoomTypesList: React.FC<RoomTypesListProps> = ({
  EditModal,
  selectedAccommodation,
  loading,
  parametersForWithoutRateplan,
  updatedParametersForWithoutRateplan,
  setUpdatedParametersForWithoutRateplan,
  parametersForMultiRateplan,
  setParametersForMultiRateplan,
  updatedParametersForMultiRateplan,
  setUpdatedParametersForMultiRateplan,
  haveSuppurtRatePlans,
  searchInput
}) => {
  const classes = useStyles()

  const onChangePMSCodeInput = (AdotelCode: string, newChannelCode: string) => {
    if (haveSuppurtRatePlans) {
      const existIndex = updatedParametersForMultiRateplan.parameters.findIndex(
        (ele) => ele.AdotelCode === AdotelCode
      )
      if (existIndex === -1) {
        const updatedObj = parametersForMultiRateplan.parameters.find(
          (ele) => ele.AdotelCode === AdotelCode
        )
        if (updatedObj) {
          updatedObj.ChannelCode = newChannelCode
          setUpdatedParametersForMultiRateplan((prevState) => ({
            parameters: [...prevState.parameters, updatedObj],
            active: prevState.active,
            channelCode: prevState.channelCode
          }))
        }
      } else {
        const updatedObj = {
          ...updatedParametersForMultiRateplan.parameters[existIndex]
        }
        updatedObj.ChannelCode = newChannelCode
        setUpdatedParametersForMultiRateplan((prevState) => {
          const newState = [...prevState.parameters]
          newState[existIndex] = updatedObj
          return {
            parameters: newState,
            active: prevState.active,
            channelCode: prevState.channelCode
          }
        })
      }
    } else {
      const existIndex =
        updatedParametersForWithoutRateplan.parameters.findIndex(
          (ele) => ele.AdotelCode === AdotelCode
        )
      if (existIndex === -1) {
        const updatedObj = parametersForWithoutRateplan.parameters.find(
          (ele) => ele.AdotelCode === AdotelCode
        )
        if (updatedObj) {
          updatedObj.ChannelCode = newChannelCode
          setUpdatedParametersForWithoutRateplan((prevState) => ({
            active: prevState.active,
            channelCode: prevState.channelCode,
            parameters: [...prevState.parameters, updatedObj]
          }))
        }
      } else {
        const updatedObj = {
          ...updatedParametersForWithoutRateplan.parameters[existIndex]
        }
        updatedObj.ChannelCode = newChannelCode
        setUpdatedParametersForWithoutRateplan((prevState) => {
          const newState = [...prevState.parameters]
          newState[existIndex] = updatedObj
          return {
            active: prevState.active,
            channelCode: prevState.channelCode,
            parameters: newState
          }
        })
      }
    }
  }

  const onRatePlansChange = (
    AdotelCode: string,
    rateplans: RatePlanForChannelapping[],
    updatedRateplans: RatePlanForChannelMappingWithRatePlanInput[]
  ) => {
    if (haveSuppurtRatePlans) {
      const tmpObject = parametersForMultiRateplan.parameters.find(
        (item) => item.AdotelCode === AdotelCode
      )
      const newObjectWithRatePlan = tmpObject
        ? {
            ...tmpObject,
            RatePlans: updatedRateplans
          }
        : undefined
      if (newObjectWithRatePlan) {
        const isExistIndex =
          updatedParametersForMultiRateplan.parameters.findIndex(
            (ele) => ele.AdotelCode === AdotelCode
          )

        if (isExistIndex === -1) {
          setUpdatedParametersForMultiRateplan((prevState) => ({
            parameters: [...prevState.parameters, newObjectWithRatePlan],
            active: prevState.active,
            channelCode: prevState.channelCode
          }))
        } else {
          const updatedObj = {
            ...updatedParametersForMultiRateplan.parameters[isExistIndex]
          }
          updatedObj.RatePlans = updatedRateplans
          setUpdatedParametersForMultiRateplan((prevState) => {
            const newState = [...prevState.parameters]
            newState[isExistIndex] = updatedObj
            return {
              parameters: newState,
              active: prevState.active,
              channelCode: prevState.channelCode
            }
          })
        }
      }
    } else {
      const newRatePlan = rateplans.filter((v) => v.ChannelCode === 'NoData')[0]
      const existIndex =
        updatedParametersForWithoutRateplan.parameters.findIndex(
          (ele) => ele.AdotelCode === AdotelCode
        )
      if (existIndex === -1) {
        const updatedObj = parametersForWithoutRateplan.parameters.find(
          (ele) => ele.AdotelCode === AdotelCode
        )
        if (updatedObj && newRatePlan && !!newRatePlan.AdotelCode) {
          updatedObj.RatePlan = newRatePlan.AdotelCode
        }
        if (updatedObj) {
          setUpdatedParametersForWithoutRateplan((prevState) => ({
            active: prevState.active,
            channelCode: prevState.channelCode,
            parameters: [...prevState.parameters, updatedObj]
          }))
        }
      } else {
        const updatedObj = {
          ...updatedParametersForWithoutRateplan.parameters[existIndex]
        }
        updatedObj.RatePlan =
          newRatePlan && !!newRatePlan.AdotelCode ? newRatePlan.AdotelCode : ''
        setUpdatedParametersForWithoutRateplan((prevState) => {
          const newState = [...prevState.parameters]
          newState[existIndex] = updatedObj
          return {
            active: prevState.active,
            channelCode: prevState.channelCode,
            parameters: newState
          }
        })
      }
    }
  }

  function updatePMSCodeInRatePlans(
    data: ChannelMappingWithRatePlanInput,
    updatedRateplans: RatePlanForChannelMappingWithRatePlanInput[],
    AdotelCode: string
  ): ChannelMappingWithRatePlanInput {
    return {
      active: data.active,
      channelCode: data.channelCode,
      parameters: data.parameters.map((item) => {
        if (item.AdotelCode === AdotelCode) {
          const updatedRatePlans = item.RatePlans?.map((ratePlan) => {
            const updatedRatePlan = updatedRateplans.find(
              (updated) => updated.AdotelCode === ratePlan.AdotelCode
            )
            if (updatedRatePlan) {
              return {
                ...ratePlan,
                ChannelCode: updatedRatePlan.ChannelCode
              }
            }

            return ratePlan
          })

          return {
            ...item,
            RatePlans: updatedRatePlans
          }
        }

        return item
      })
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.listContainer}>
        {loading
          ? Array(6)
              .fill('')
              .map((item, index) => (
                <RoomTypeItemBoxSkeleton
                  key={`roomtypebox-skeleton${item}${index.toString()}`}
                />
              ))
          : selectedAccommodation?.RoomTypes.map(
              (item, roomTypeIndex) =>
                (item.AdotelName.toLocaleLowerCase().includes(
                  searchInput.toLocaleLowerCase()
                ) ||
                  item.AdotelCode.toLocaleLowerCase().includes(
                    searchInput.toLocaleLowerCase()
                  )) && (
                  <RoomTypeItemBox
                    key={roomTypeIndex}
                    data={item}
                    EditModal={EditModal}
                    onRatePlansChange={(
                      AdotelCode: string,
                      rateplans: RatePlanForChannelapping[],
                      updatedRateplans: RatePlanForChannelMappingWithRatePlanInput[]
                    ) => {
                      onRatePlansChange(AdotelCode, rateplans, updatedRateplans)

                      const updatedData = updatePMSCodeInRatePlans(
                        parametersForMultiRateplan,
                        updatedRateplans,
                        AdotelCode
                      )

                      setParametersForMultiRateplan(updatedData)
                    }}
                    onChangePMSCodeInput={(AdotelCode, newChannelCode) => {
                      onChangePMSCodeInput(AdotelCode, newChannelCode)
                    }}
                    haveSuppurtRatePlans={haveSuppurtRatePlans}
                  />
                )
            )}
      </div>
    </div>
  )
}

export default RoomTypesList
